/* Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Spacer, theme } from "@nordcloud/gnui";
import { FilterHeader, Mode, getSelectedMode } from "~/components";
import { FiltersProp } from "~/models/estateRecordRow";
import { noop } from "~/tools";
import { EstateDateRangeFilter } from "./EstateDateRangeFilter";

type Props = {
  filters: FiltersProp;
  updateFilters: (input: FiltersProp) => void;
  isExcludeSelected?: boolean;
  onModeChange?: (mode: Mode) => void;
};

export function DiscoveryTimeFilter({
  filters,
  updateFilters,
  isExcludeSelected,
  onModeChange,
}: Props) {
  const { firstSeenAtFrom = "", firstSeenAtTo = "" } = filters;

  return (
    <>
      <FilterHeader
        allowModeChange
        defaultMode={getSelectedMode(isExcludeSelected)}
        onSetSearch={noop}
        onModeChange={onModeChange}
      />
      <Spacer height={theme.spacing.spacing04} />
      <EstateDateRangeFilter
        description="The time range when the resource was discovered"
        dateFrom={firstSeenAtFrom}
        dateTo={firstSeenAtTo}
        onDateFromChange={(value) =>
          updateFilters({
            firstSeenAtFrom: value,
          })
        }
        onDateToChange={(value) =>
          updateFilters({
            firstSeenAtTo: value,
          })
        }
      />
    </>
  );
}
